module.exports = __webpack_public_path__ + "static/media/glab-metrics-square.7d931e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/glab-metrics-square.png
// module id = 409
// module chunks = 0